type RawSql = (query: string, params?: unknown[]) => Promise<unknown>;

const SERVICE_CREDIT_GRANT_SCHEMA_STATEMENTS = [
  `CREATE TABLE IF NOT EXISTS service_credit_ledger (
      id SERIAL PRIMARY KEY,
      user_id TEXT NOT NULL,
      type TEXT NOT NULL,
      amount REAL NOT NULL,
      balance_after REAL NOT NULL,
      title TEXT NOT NULL,
      service_type TEXT,
      provider TEXT,
      expires_at TIMESTAMP,
      app_id INTEGER,
      payment_ref TEXT,
      remaining REAL,
      created_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `ALTER TABLE service_credit_ledger ADD COLUMN IF NOT EXISTS remaining REAL`,
  `CREATE TABLE IF NOT EXISTS coupons (
      id SERIAL PRIMARY KEY,
      code TEXT NOT NULL UNIQUE,
      title TEXT NOT NULL,
      credit_amount REAL NOT NULL,
      credit_expiry_days INTEGER NOT NULL DEFAULT 365,
      max_redemptions INTEGER,
      redemption_count INTEGER NOT NULL DEFAULT 0,
      expires_at TIMESTAMP NOT NULL,
      status TEXT NOT NULL DEFAULT 'active',
      redemption_mode TEXT NOT NULL DEFAULT 'manual',
      system_key TEXT,
      description TEXT,
      created_by TEXT NOT NULL,
      created_at TIMESTAMP DEFAULT NOW() NOT NULL,
      updated_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `ALTER TABLE coupons ADD COLUMN IF NOT EXISTS redemption_mode TEXT NOT NULL DEFAULT 'manual'`,
  `ALTER TABLE coupons ADD COLUMN IF NOT EXISTS system_key TEXT`,
  `ALTER TABLE coupons ADD COLUMN IF NOT EXISTS updated_at TIMESTAMP NOT NULL DEFAULT NOW()`,
  `CREATE INDEX IF NOT EXISTS coupons_code_idx ON coupons (code)`,
  `CREATE INDEX IF NOT EXISTS coupons_status_idx ON coupons (status)`,
  `CREATE INDEX IF NOT EXISTS coupons_expires_at_idx ON coupons (expires_at)`,
  `CREATE UNIQUE INDEX IF NOT EXISTS coupons_system_key_idx
      ON coupons (system_key)
      WHERE system_key IS NOT NULL`,
  `CREATE TABLE IF NOT EXISTS coupon_redemptions (
      id SERIAL PRIMARY KEY,
      coupon_id INTEGER NOT NULL,
      user_id TEXT NOT NULL,
      credit_amount REAL NOT NULL,
      source TEXT NOT NULL DEFAULT 'manual',
      idempotency_key TEXT,
      ledger_entry_id INTEGER,
      credit_expires_at TIMESTAMP NOT NULL,
      created_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `ALTER TABLE coupon_redemptions ADD COLUMN IF NOT EXISTS source TEXT NOT NULL DEFAULT 'manual'`,
  `ALTER TABLE coupon_redemptions ADD COLUMN IF NOT EXISTS idempotency_key TEXT`,
  `ALTER TABLE coupon_redemptions ADD COLUMN IF NOT EXISTS ledger_entry_id INTEGER`,
  `DROP INDEX IF EXISTS coupon_redemptions_coupon_user_idx`,
  `CREATE UNIQUE INDEX IF NOT EXISTS coupon_redemptions_manual_coupon_user_idx
      ON coupon_redemptions (coupon_id, user_id)
      WHERE source = 'manual'`,
  `CREATE UNIQUE INDEX IF NOT EXISTS coupon_redemptions_idempotency_key_idx
      ON coupon_redemptions (idempotency_key)
      WHERE idempotency_key IS NOT NULL`,
  `CREATE INDEX IF NOT EXISTS coupon_redemptions_user_idx ON coupon_redemptions (user_id)`,
  `CREATE INDEX IF NOT EXISTS coupon_redemptions_coupon_idx ON coupon_redemptions (coupon_id)`,
  `CREATE TABLE IF NOT EXISTS service_credit_grant_policies (
      id SERIAL PRIMARY KEY,
      event_type TEXT NOT NULL,
      from_plan TEXT,
      to_plan TEXT,
      coupon_id INTEGER NOT NULL,
      enabled BOOLEAN NOT NULL DEFAULT true,
      once_scope TEXT NOT NULL DEFAULT 'event',
      grant_timing TEXT NOT NULL DEFAULT 'anchor_open',
      anchor_day INTEGER NOT NULL DEFAULT 1,
      timezone TEXT NOT NULL DEFAULT 'Asia/Seoul',
      credit_expiry_mode TEXT NOT NULL DEFAULT 'coupon_days',
      expiry_grace_days INTEGER,
      created_by TEXT NOT NULL,
      updated_by TEXT NOT NULL,
      created_at TIMESTAMP DEFAULT NOW() NOT NULL,
      updated_at TIMESTAMP DEFAULT NOW() NOT NULL
  )`,
  `ALTER TABLE service_credit_grant_policies ADD COLUMN IF NOT EXISTS grant_timing TEXT NOT NULL DEFAULT 'anchor_open'`,
  `ALTER TABLE service_credit_grant_policies ADD COLUMN IF NOT EXISTS anchor_day INTEGER NOT NULL DEFAULT 1`,
  `ALTER TABLE service_credit_grant_policies ADD COLUMN IF NOT EXISTS timezone TEXT NOT NULL DEFAULT 'Asia/Seoul'`,
  `ALTER TABLE service_credit_grant_policies ADD COLUMN IF NOT EXISTS credit_expiry_mode TEXT NOT NULL DEFAULT 'coupon_days'`,
  `ALTER TABLE service_credit_grant_policies ADD COLUMN IF NOT EXISTS expiry_grace_days INTEGER`,
  `CREATE TABLE IF NOT EXISTS service_credit_grant_runs (
      id SERIAL PRIMARY KEY,
      event_type TEXT NOT NULL DEFAULT 'monthly_anchor',
      period_start TIMESTAMP NOT NULL,
      period_end TIMESTAMP NOT NULL,
      status TEXT NOT NULL DEFAULT 'running',
      dry_run BOOLEAN NOT NULL DEFAULT true,
      started_at TIMESTAMP DEFAULT NOW() NOT NULL,
      completed_at TIMESTAMP,
      processed_count INTEGER NOT NULL DEFAULT 0,
      granted_count INTEGER NOT NULL DEFAULT 0,
      skipped_count INTEGER NOT NULL DEFAULT 0,
      failed_count INTEGER NOT NULL DEFAULT 0,
      error TEXT
  )`,
  `CREATE UNIQUE INDEX IF NOT EXISTS service_credit_grant_policy_event_idx
      ON service_credit_grant_policies (
          event_type,
          COALESCE(from_plan, '__null__'),
          COALESCE(to_plan, '__null__')
      )`,
  `UPDATE coupons
      SET system_key = 'signup_welcome_5k',
          redemption_mode = 'system',
          updated_at = NOW()
      WHERE code = 'SYS-SIGNUP-WELCOME-5K'
        AND (system_key IS NULL OR system_key = 'signup_welcome_5k')`,
  `INSERT INTO coupons (
      code, title, credit_amount, credit_expiry_days, max_redemptions, expires_at, status,
      redemption_mode, system_key, description, created_by, updated_at
  )
  SELECT
      'SYS-SIGNUP-WELCOME-5K',
      'Signup welcome service credits',
      5000,
      90,
      NULL,
      '2099-12-31',
      'active',
      'system',
      'signup_welcome_5k',
      'Default signup welcome service credit grant.',
      'system',
      NOW()
  WHERE NOT EXISTS (SELECT 1 FROM coupons WHERE system_key = 'signup_welcome_5k')`,
  `UPDATE coupons
      SET title = 'Signup welcome service credits',
          credit_amount = 5000,
          credit_expiry_days = 90,
          redemption_mode = 'system',
          description = 'Default signup welcome service credit grant.',
          updated_at = NOW()
      WHERE system_key = 'signup_welcome_5k'`,
  `UPDATE coupons
      SET system_key = 'startup_plan_grant_100k',
          redemption_mode = 'system',
          updated_at = NOW()
      WHERE code = 'SYS-STARTUP-GRANT-100K'
        AND (system_key IS NULL OR system_key = 'startup_plan_grant_100k')`,
  `INSERT INTO coupons (
      code, title, credit_amount, credit_expiry_days, max_redemptions, expires_at, status,
      redemption_mode, system_key, description, created_by, updated_at
  )
  SELECT
      'SYS-STARTUP-GRANT-100K',
      'Startup plan service credit grant',
      100000,
      365,
      NULL,
      '2099-12-31',
      'active',
      'system',
      'startup_plan_grant_100k',
      'Default one-time service credit grant for Startup plan transitions.',
      'system',
      NOW()
  WHERE NOT EXISTS (SELECT 1 FROM coupons WHERE system_key = 'startup_plan_grant_100k')`,
  `UPDATE coupons
      SET title = 'Startup plan service credit grant',
          credit_amount = 100000,
          credit_expiry_days = 365,
          redemption_mode = 'system',
          description = 'Default one-time service credit grant for Startup plan transitions.',
          updated_at = NOW()
      WHERE system_key = 'startup_plan_grant_100k'`,
  `INSERT INTO service_credit_grant_policies (
      event_type, from_plan, to_plan, coupon_id, enabled, once_scope, created_by, updated_by
  )
  SELECT 'signup', NULL, NULL, c.id, true, 'user', 'system', 'system'
  FROM coupons c
  WHERE c.system_key = 'signup_welcome_5k'
    AND NOT EXISTS (
        SELECT 1 FROM service_credit_grant_policies p
        WHERE p.event_type = 'signup' AND p.from_plan IS NULL AND p.to_plan IS NULL
    )`,
  `UPDATE service_credit_grant_policies p
      SET coupon_id = c.id,
          enabled = true,
          once_scope = 'user',
          updated_by = 'system',
          updated_at = NOW()
      FROM coupons c
      WHERE c.system_key = 'signup_welcome_5k'
        AND p.event_type = 'signup'
        AND p.from_plan IS NULL
        AND p.to_plan IS NULL`,
  `INSERT INTO service_credit_grant_policies (
      event_type, from_plan, to_plan, coupon_id, enabled, once_scope, created_by, updated_by
  )
  SELECT 'plan_change', '*', 'scale', c.id, true, 'user_to_plan', 'system', 'system'
  FROM coupons c
  WHERE c.system_key = 'startup_plan_grant_100k'
    AND NOT EXISTS (
        SELECT 1 FROM service_credit_grant_policies p
        WHERE p.event_type = 'plan_change' AND p.from_plan = '*' AND p.to_plan = 'scale'
    )`,
  `UPDATE service_credit_grant_policies p
      SET coupon_id = c.id,
          enabled = true,
          once_scope = 'user_to_plan',
          updated_by = 'system',
          updated_at = NOW()
      FROM coupons c
      WHERE c.system_key = 'startup_plan_grant_100k'
        AND p.event_type = 'plan_change'
        AND p.from_plan = '*'
        AND p.to_plan = 'scale'`,
  `UPDATE coupons
      SET system_key = 'hobby_monthly_service_5k',
          redemption_mode = 'system',
          updated_at = NOW()
      WHERE code = 'SYS-HOBBY-MONTHLY-SERVICE-5K'
        AND (system_key IS NULL OR system_key = 'hobby_monthly_service_5k')`,
  `INSERT INTO coupons (
      code, title, credit_amount, credit_expiry_days, max_redemptions, expires_at, status,
      redemption_mode, system_key, description, created_by, updated_at
  )
  SELECT
      'SYS-HOBBY-MONTHLY-SERVICE-5K',
      'Hobby monthly service credits',
      5000,
      31,
      NULL,
      '2099-12-31',
      'active',
      'system',
      'hobby_monthly_service_5k',
      'Default monthly service credit grant for Hobby/free plans.',
      'system',
      NOW()
  WHERE NOT EXISTS (SELECT 1 FROM coupons WHERE system_key = 'hobby_monthly_service_5k')`,
  `UPDATE coupons
      SET title = 'Hobby monthly service credits',
          credit_amount = 5000,
          credit_expiry_days = 31,
          redemption_mode = 'system',
          description = 'Default monthly service credit grant for Hobby/free plans.',
          updated_at = NOW()
      WHERE system_key = 'hobby_monthly_service_5k'`,
  `INSERT INTO service_credit_grant_policies (
      event_type, from_plan, to_plan, coupon_id, enabled, once_scope,
      grant_timing, anchor_day, timezone, credit_expiry_mode, expiry_grace_days,
      created_by, updated_by
  )
  SELECT 'monthly_anchor', NULL, 'free', c.id, true, 'user_period',
         'anchor_open', 1, 'Asia/Seoul', 'period_end_plus_grace', 7,
         'system', 'system'
  FROM coupons c
  WHERE c.system_key = 'hobby_monthly_service_5k'
    AND NOT EXISTS (
        SELECT 1 FROM service_credit_grant_policies p
        WHERE p.event_type = 'monthly_anchor' AND p.from_plan IS NULL AND p.to_plan = 'free'
    )`,
  `UPDATE service_credit_grant_policies p
      SET coupon_id = c.id,
          enabled = true,
          once_scope = 'user_period',
          grant_timing = 'anchor_open',
          anchor_day = 1,
          timezone = 'Asia/Seoul',
          credit_expiry_mode = 'period_end_plus_grace',
          expiry_grace_days = 7,
          updated_by = 'system',
          updated_at = NOW()
      FROM coupons c
      WHERE c.system_key = 'hobby_monthly_service_5k'
        AND p.event_type = 'monthly_anchor'
        AND p.from_plan IS NULL
        AND p.to_plan = 'free'`,
  `UPDATE coupons
      SET system_key = 'scale_monthly_service_100k',
          redemption_mode = 'system',
          updated_at = NOW()
      WHERE code = 'SYS-SCALE-MONTHLY-SERVICE-100K'
        AND (system_key IS NULL OR system_key = 'scale_monthly_service_100k')`,
  `INSERT INTO coupons (
      code, title, credit_amount, credit_expiry_days, max_redemptions, expires_at, status,
      redemption_mode, system_key, description, created_by, updated_at
  )
  SELECT
      'SYS-SCALE-MONTHLY-SERVICE-100K',
      'Startup monthly service credits',
      100000,
      31,
      NULL,
      '2099-12-31',
      'active',
      'system',
      'scale_monthly_service_100k',
      'Default monthly service credit grant for Startup/Scale plans.',
      'system',
      NOW()
  WHERE NOT EXISTS (SELECT 1 FROM coupons WHERE system_key = 'scale_monthly_service_100k')`,
  `UPDATE coupons
      SET title = 'Startup monthly service credits',
          credit_amount = 100000,
          credit_expiry_days = 31,
          redemption_mode = 'system',
          description = 'Default monthly service credit grant for Startup/Scale plans.',
          updated_at = NOW()
      WHERE system_key = 'scale_monthly_service_100k'`,
  `INSERT INTO service_credit_grant_policies (
      event_type, from_plan, to_plan, coupon_id, enabled, once_scope,
      grant_timing, anchor_day, timezone, credit_expiry_mode, expiry_grace_days,
      created_by, updated_by
  )
  SELECT 'monthly_anchor', NULL, 'scale', c.id, true, 'user_period',
         'anchor_open', 1, 'Asia/Seoul', 'period_end_plus_grace', 7,
         'system', 'system'
  FROM coupons c
  WHERE c.system_key = 'scale_monthly_service_100k'
    AND NOT EXISTS (
        SELECT 1 FROM service_credit_grant_policies p
        WHERE p.event_type = 'monthly_anchor' AND p.from_plan IS NULL AND p.to_plan = 'scale'
    )`,
  `UPDATE service_credit_grant_policies p
      SET coupon_id = c.id,
          enabled = true,
          once_scope = 'user_period',
          grant_timing = 'anchor_open',
          anchor_day = 1,
          timezone = 'Asia/Seoul',
          credit_expiry_mode = 'period_end_plus_grace',
          expiry_grace_days = 7,
          updated_by = 'system',
          updated_at = NOW()
      FROM coupons c
      WHERE c.system_key = 'scale_monthly_service_100k'
        AND p.event_type = 'monthly_anchor'
        AND p.from_plan IS NULL
        AND p.to_plan = 'scale'`,
];

export async function ensureServiceCreditGrantPolicySchema(params: { rawSql: RawSql }): Promise<void> {
  for (const statement of SERVICE_CREDIT_GRANT_SCHEMA_STATEMENTS) {
    await params.rawSql(statement);
  }
}
